import React, { Component } from "react";
import HomologarPropietarioComponent from "../../../components/personaReferencia/homologarPropietario/HomologarPropietarioComponent";
import { homologarPropietarioStore } from "./HomologarPropietario.store";
import { homologarPropietarioDispatcher } from "./HomologarPropietario.dispatcher";
import { ReduxConnect } from "../../../../toolkit/decorators/Artifact";
import ModalFrame from "../../../../toolkit/modalFrame";

interface Props {
  idMembresiaSocio: number;
  idPropietario: number;
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
}

interface State {}

@ReduxConnect(homologarPropietarioStore, homologarPropietarioDispatcher)
export default class HomologarPropietarioModal extends Component<Props, State> {
  state = {};

  render() {
    return (
      <ModalFrame
        title="Homologar Propietario"
        isOpen={this.props.isOpen}
        toggle={this.props.onClose}
        size="md"
      >
        <HomologarPropietarioComponent {...(this.props as any)} />
      </ModalFrame>
    );
  }
}
